<script lang="ts" setup>
import { useAppConfig } from '#app/config';
import { useChatStore } from '#layers/ai/stores/chat';
import { aiChatConversationDownloadFlag } from '#layers/base/public';

const appConfig = useAppConfig();
const chatStore = useChatStore();

function downloadConversation() {
	const blob = new Blob([JSON.stringify(chatStore.messages, null, 2)], {
		type: 'application/json',
	});
	const objectUrl = URL.createObjectURL(blob);
	const anchor = document.createElement('a');

	anchor.href = objectUrl;
	anchor.download = `monospace-ai-conversation-${new Date().toISOString().replaceAll(':', '-')}.json`;

	try {
		anchor.click();
	}
	finally {
		URL.revokeObjectURL(objectUrl);
	}
}

function resetChat() {
	chatStore.reset();
}
</script>

<template>
	<div class="flex h-10 shrink-0 items-center justify-end gap-1">
		<DTooltip v-if="aiChatConversationDownloadFlag" :text="$t('ai.chat.download_conversation')">
			<DButton
				data-testid="download-ai-chat-button"
				:icon="appConfig.ui.icons.download"
				size="sm"
				color="neutral"
				variant="ghost"
				square
				:disabled="chatStore.messages.length === 0"
				:aria-label="$t('ai.chat.download_conversation')"
				@click="downloadConversation"
			/>
		</DTooltip>

		<DTooltip :text="$t('ai.chat.start_new')">
			<DButton
				data-testid="reset-ai-chat-button"
				icon="lucide:message-circle-plus"
				size="sm"
				color="neutral"
				variant="ghost"
				square
				:aria-label="$t('ai.chat.start_new')"
				@click="resetChat"
			/>
		</DTooltip>
	</div>
</template>
